import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sort: '',
    filter: 'All',
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        sortOption: (state, action)=>{
            state.sort = action.payload;
        },
        filterOption: (state, action)=>{
            state.filter = action.payload;
        }
    },
});

export default filterSlice.reducer;
export const {sortOption, filterOption} = filterSlice.actions;